module.exports = __webpack_public_path__ + "static/media/  (120).864d2623.jpg";